<kTags
  *ngIf="_showTags"
  [title]="'applications.content.filters.activeFilters' | translate"
  [data]="_tags"
  [labelField]="'label'"
  [disabledField]="'disabled'"
  [tooltipField]="'tooltip'"
  [clearAllLabel]="'applications.content.filters.clearAll' | translate"
  (onTagRemove)="removeTag($event)"
  (onRemoveAll)="removeAllTags()"
  (onTagsChange)="onTagsChange.emit($event)"
>
  <ng-template let-item="item">
    <div class="kTagContent" [class.kTagDisabled]="item.data?.disabled" [kTooltip]="item.tooltip">
      <span class="kTagLabel">{{ item.label }}</span>
      <i
        *ngIf="item.showRemove"
        class="kTagRemove kIconclose_small"
        (click)="!item.data?.disabled && removeTag(item.data)"
      ></i>
    </div>
  </ng-template>
</kTags>
